export default [
    {
        path: "/rent-adjustment",
        name: "Rent Adjustment",
        component: require("@/components/RentAdjustment/ListRentAdjustment").default,
        meta: {
            breadcrumbs: [
                {
                    name: "Pembaruan Order",
                }
            ]
        }
    },
    {
        path: "/rent-adjustment/:id",
        name: "Create Rent Adjustment",
        component: require("@/components/RentAdjustment/FormRentAdjustment").default,
        meta: {
            breadcrumbs: [
                {
                    name: "Pembaruan Order",
                    path: '/rent-adjustment',
                    query: {
                        orderId: '',
                        productCode: '',
                        leaseType: '',
                        status: '',
                        firstLessee: '',
                        targetLessee: '',
                        status: '',
                        dateEfectiveTo: '',
                        dateEfectiveFrom: '',
                        itemPerPage: 10,
                        page: 1
                    }
                },
                {
                    name: "Transfer Entitas",
                }
            ]
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/rentAdjustment/index.js